"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { ErrorPage } from "@/components/error-page";
import rootLogger from "@/lib/logging";

const logger = rootLogger.child({ component: "error-boundary" });

export function TrackedErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const path = usePathname();

  useEffect(() => {
    const message = "Runtime error caught at the error boundary";
    logger.error({ path, message: error.message, stack: error.stack }, message);

    void import("@/lib/capture-client-error")
      .then(({ captureClientError }) =>
        captureClientError(error, { path, message })
      )
      .catch(() => {
        // Tracking may be unavailable while rendering an error boundary.
      });
  }, [error, path]);

  return (
    <ErrorPage
      statusCode="500"
      title="Something went wrong"
      description="An unexpected error occurred. Please try again."
      actionLabel="Try again"
      onAction={reset}
    />
  );
}
